export const selectIsLoggedIn = (state) =>
  Boolean(state.authTeacher.teacherToken);
export const selectAuthError = (state) => state.authTeacher.error;
export const selectAccessToken = (state) => state.authTeacher.teacherToken;
export const selectAuthLoading = (state) => state.authTeacher.loading;
export const selectIsRefreshing = (state) => state.authTeacher.isRefreshing;
export const selectRefreshToken = (state) => state.authTeacher.refreshToken;
export const selectIsRefreshingSession = (state) =>
  state.authTeacher.isRefreshingSession;
export const teacherDataSelector = (state) => state.authTeacher.teacherData;
